import React, { useEffect, useMemo } from "react"
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import Color from 'color'

function getUserBrowserLanguage(locale) {
  const allowed = ['en-US', 'fr', 'de', 'es', 'it'];

  return allowed.includes(locale) ? locale : allowed.includes(locale.substring(0, 2)) ? locale.substring(0, 2) : 'en-US';
}

function initEmbeddedMessaging(language, isEda = false) {
  if (!window.embeddedservice_bootstrap) { return }

  window.embeddedservice_bootstrap.settings.language = getUserBrowserLanguage(language)
  window.embeddedservice_bootstrap.settings.targetElement = window.liveagentroot

  const deploymentId = isEda ? process.env.REACT_APP_EDA_LIVE_AGENT_DEPLOYMENT_ID : process.env.REACT_APP_LIVE_AGENT_DEPLOYMENT_ID
  const baseContentUrl = isEda ? process.env.REACT_APP_EDA_LIVE_AGENT_BASE_CONTENT_URL : process.env.REACT_APP_LIVE_AGENT_BASE_CONTENT_URL

  window.embeddedservice_bootstrap.init(
    process.env.REACT_APP_LIVE_AGENT_ORG_ID,
    deploymentId,
    baseContentUrl,
    {
      scrt2URL: process.env.REACT_APP_LIVE_AGENT_BASE_URL,
      isOfflineSupportEnabled: false
    }
  );
};

function initLiveAgent(language, isEda) {
  var script = document.createElement('script');
  script.src = isEda ? process.env.REACT_APP_EDA_LIVE_AGENT_SCRIPT_SRC : process.env.REACT_APP_LIVE_AGENT_SCRIPT_SRC
  script.onload = function () {
    initEmbeddedMessaging(language, isEda);
  };
  document.body.appendChild(script);
}

export default function LiveAgent({ portalConfiguration }) {
  const { i18n } = useTranslation()
  const location = useLocation()
  const isSupportPage = useMemo(() => location.pathname.includes('/support'), [location])

  const { liveagent_enabled, main_color, tag, theme, text_colors } = portalConfiguration

  useEffect(() => {
    if (liveagent_enabled) {
      // Used by iloscamonde
      const isEda = tag?.match("iloscamonde")
      const displayNow = isEda || isSupportPage
      setTimeout(() => initLiveAgent(i18n.language, isEda), (displayNow ? 0.5 : 10) * 1000)
    }
  }, [i18n.language, liveagent_enabled, isSupportPage, tag])

  const color = theme === 'dark' ? '#008CC7' : main_color
  const hoverColor = Color(color).darken(.3).rgb().toString()
  const textColor = text_colors?.titleColor || 'white';

  return <style type='text/css'>
    {
      `.embedded-messaging button {
      --eswButtonColor: ${color} !important;
      --eswButtonHoverColor: ${hoverColor} !important;
      --eswIconFillColor: ${textColor} !important;
      `
    }
  </style>
}
